import * as React from 'react';

import styles from './Preloader.css';
import { isImage } from '../../../../utils/carousel';
import { getYoutubeVideoPreviewUrl } from '../../../mobile/slider/youtube';
import { TMediaItemSchema } from '../../interfaces';
import { Image } from '../Image';
import { NoImage } from '../NoImage';

interface IProps {
  media: TMediaItemSchema[] | null;
}

const getMedia = (props: IProps) => {
  const { media } = props;
  if (media) {
    const lastItem = media[media.length - 1];

    return [lastItem, ...media.slice(0, 3)].filter(Boolean);
  }

  return null;
};

export const Preloader = (props: IProps) => {
  const media = getMedia(props);

  if (media) {
    return (
      <div className={styles['preloader']}>
        <div className={styles['preloader-content']}>
          {media.map(item => {
            const src = isImage(item) ? item.galleryThumbnailUrl : getYoutubeVideoPreviewUrl(item.videoUrl);

            return (
              <div className={styles['preloader-img_item']} key={src}>
                <Image src={src} alt="" />
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return <NoImage text="Загрузка" />;
};
